import ProviderAPI from "../redux/ProviderAPI";

export const getYachtInfoAmenities = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "yachtInfoAmenities/detailYachtInfoAmenities",
    data,
    token,
  });
  return result;
};
